import { dataArrowUp } from 'dls-icons-data'
import { createIcon } from '../common'

const IconArrowUp = /*#__PURE__*/createIcon(dataArrowUp)
export default IconArrowUp
